import { ProposalI } from "../interfaces/proposal.interface"
import { ProposalService } from "../services/proposal.service"
import { CreateProposalPayload, GetProposalByIdResponseT, GetProposalFilters, GetProposalResponseT } from "../types/proposal.types"

const proposalService = new ProposalService()

class ProposalRealisation implements ProposalI {
    getProposal(filters: GetProposalFilters): Promise<GetProposalResponseT> {
        return proposalService.getProposal(filters)
    }

    createProposal(payload: CreateProposalPayload): Promise<void> {
        return proposalService.createProposal(payload)
    }

    getProposalById(proposal_id: number): Promise<GetProposalByIdResponseT> {
        return proposalService.getProposalById(proposal_id)
    }

    updateProposal(proposal_id: number, payload: CreateProposalPayload): Promise<void> {
        return proposalService.updateProposal(proposal_id, payload)
    }

    deleteProposal(proposal_id: number): Promise<void> {
        return proposalService.deleteProposal(proposal_id)
    }

    closeProposal(proposal_id: number): Promise<void> {
        return proposalService.closeProposal(proposal_id)
    }
}

export const proposal = new ProposalRealisation()
